import { ChakraFlex, ChakraText, EquipUITheme } from '@equip.health/ui';
import { PatientNoteListItemType } from '~/lib/constants/AddPatientNoteModal.constants';
import { isThisYear } from '~/lib/util/patientActivity.util';
import { DateTime } from 'luxon';
import { getPreferredFullName } from '~/lib/util/patient.util';

const { label, labelBold } = EquipUITheme.typography;

type Props = {
  idPrefix: string;
  note: PatientNoteListItemType;
};

export const PatientNoteItemSignedRow = ({ idPrefix, note }: Props) => {
  const { lastModifiedProviderExternalId, signedAtDateTime, signedBy } = note;

  const signedAt = DateTime.fromISO(signedAtDateTime);
  const signedDate = isThisYear(signedAtDateTime)
    ? `${signedAt.monthLong} ${signedAt.day}`
    : signedAt.toLocaleString(DateTime.DATE_MED);
  const signedTime = signedAt.toLocaleString(DateTime.TIME_SIMPLE);

  const getSignedBy = (): string => {
    if (signedBy) {
      return getPreferredFullName(
        null,
        signedBy?.firstName,
        signedBy?.lastName,
      );
    }
    if (lastModifiedProviderExternalId === 'Task manager') {
      return 'System';
    }
    return '--';
  };

  return (
    <ChakraFlex marginBottom="24px">
      <ChakraText
        {...labelBold}
        id={`${idPrefix}__signed-label`}
        lineHeight="16.8px"
      >
        Signed
      </ChakraText>
      <ChakraText
        {...label}
        color="neutral.secondary"
        id={`${idPrefix}__by-label`}
        lineHeight="16.8px"
        marginLeft="16px"
      >
        by
      </ChakraText>
      <ChakraText
        {...label}
        color="neutral.secondary"
        id={`${idPrefix}__signed-by-name`}
        lineHeight="16.8px"
        marginLeft="8px"
      >
        {getSignedBy()}
      </ChakraText>
      <ChakraText
        {...label}
        color="neutral.secondary"
        id={`${idPrefix}__signed-by-date-time`}
        lineHeight="16.8px"
        marginLeft="8px"
      >
        {signedAtDateTime ? `${signedDate} at ${signedTime}` : '--'}
      </ChakraText>
    </ChakraFlex>
  );
};
